/**
 * Little celebrations (Jenn, 2026-09-29). Hearts are the exact effect Jenn
 * loves in Threadline (prototype/board.src.html fireHearts: 14 💖💕💛🎉
 * floating up the screen); confetti is 365reset brand-coloured pieces
 * rising up from the bottom — for the daily Compass check-in. (Jenn,
 * 2026-09-29: falling confetti "feels depressing" — so it floats upward.)
 *
 * Skipped entirely for anyone whose device is set to "reduce motion", and
 * never blocks a tap (pointer-events: none), so it can't get in the way.
 */
const STYLE_ID = 'celebrate-styles';
const css = `
.celebrate-layer{position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden}
.celebrate-heart{--dx:0px;position:absolute;bottom:-10%;font-size:24px;animation:celebrateUp 2.2s ease-in forwards}
.celebrate-bit{--dx:0px;--rot:0deg;position:absolute;bottom:-4%;width:10px;height:14px;border-radius:2px;animation:celebrateRise 2.6s ease-out forwards}
@keyframes celebrateUp{0%{transform:translateY(0) translateX(0) scale(.7);opacity:0}10%{opacity:1}100%{transform:translateY(-100vh) translateX(var(--dx)) scale(1.1);opacity:0}}
@keyframes celebrateRise{0%{transform:translateY(0) translateX(0) rotate(0);opacity:0}8%{opacity:1}100%{transform:translateY(-105vh) translateX(var(--dx)) rotate(var(--rot));opacity:0}}
`;

const reducedMotion = () => {
  try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
};

const layer = () => {
  if (!document.getElementById(STYLE_ID)) {
    const s = document.createElement('style'); s.id = STYLE_ID; s.textContent = css; document.head.appendChild(s);
  }
  const box = document.createElement('div');
  box.className = 'celebrate-layer';
  box.setAttribute('aria-hidden', 'true');
  document.body.appendChild(box);
  return box;
};

export const fireHearts = () => {
  if (reducedMotion()) return;
  const box = layer();
  const emojis = ['\u{1F496}', '\u{1F495}', '\u{1F49B}', '\u{1F389}'];
  for (let i = 0; i < 14; i++) {
    const s = document.createElement('span');
    s.className = 'celebrate-heart';
    s.textContent = emojis[i % 4];
    s.style.left = `${6 + Math.random() * 88}%`;
    s.style.setProperty('--dx', `${Math.random() * 80 - 40}px`);
    s.style.animationDelay = `${Math.random() * 0.6}s`;
    box.appendChild(s);
  }
  setTimeout(() => box.remove(), 3000);
};

// Terracotta, sage, gold, cream-dark and brown — the brand palette.
const CONFETTI_COLOURS = ['#C4714A', '#4A6355', '#DEC392', '#E4C9B4', '#2B2313'];

export const fireConfetti = () => {
  if (reducedMotion()) return;
  const box = layer();
  for (let i = 0; i < 60; i++) {
    const b = document.createElement('span');
    b.className = 'celebrate-bit';
    b.style.left = `${Math.random() * 100}%`;
    b.style.background = CONFETTI_COLOURS[i % CONFETTI_COLOURS.length];
    b.style.setProperty('--dx', `${Math.random() * 160 - 80}px`);
    b.style.setProperty('--rot', `${Math.random() * 720 - 360}deg`);
    b.style.animationDelay = `${Math.random() * 0.5}s`;
    if (i % 3 === 0) { b.style.width = '8px'; b.style.height = '8px'; b.style.borderRadius = '50%'; }
    box.appendChild(b);
  }
  setTimeout(() => box.remove(), 3200);
};
